export default {
  valueBestSales: {
    id: 'product_filter_sort_best_sales',
    defaultMessage: 'Best sales',
  },
  valuePriceAscending: {
    id: 'product_filter_sort_price_asc',
    defaultMessage: 'Lower price first',
  },
  valuePriceDescending: {
    id: 'product_filter_sort_price_desc',
    defaultMessage: 'Higher price first',
  },
}
